/*
 * Code generated by Speakeasy (https://speakeasy.com). DO NOT EDIT.
 */

import * as z from "zod/v4-mini";
import { remap as remap$ } from "../../lib/primitives.js";

export type GetUserSessionIssuerSecurityOption1 = {
  projectSlugHeaderGramProject: string;
  sessionHeaderGramSession: string;
};

export type GetUserSessionIssuerSecurityOption2 = {
  apikeyHeaderGramKey: string;
  projectSlugHeaderGramProject: string;
};

export type GetUserSessionIssuerSecurity = {
  option1?: GetUserSessionIssuerSecurityOption1 | undefined;
  option2?: GetUserSessionIssuerSecurityOption2 | undefined;
};

export type GetUserSessionIssuerRequest = {
  /**
   * The user_session_issuer id.
   */
  id?: string | undefined;
  /**
   * The user_session_issuer slug.
   */
  slug?: string | undefined;
  /**
   * Session header
   */
  gramSession?: string | undefined;
  /**
   * API Key header
   */
  gramKey?: string | undefined;
  /**
   * project header
   */
  gramProject?: string | undefined;
};

/** @internal */
export type GetUserSessionIssuerSecurityOption1$Outbound = {
  "project_slug_header_Gram-Project": string;
  "session_header_Gram-Session": string;
};

/** @internal */
export const GetUserSessionIssuerSecurityOption1$outboundSchema: z.ZodMiniType<
  GetUserSessionIssuerSecurityOption1$Outbound,
  GetUserSessionIssuerSecurityOption1
> = z.pipe(
  z.object({
    projectSlugHeaderGramProject: z.string(),
    sessionHeaderGramSession: z.string(),
  }),
  z.transform((v) => {
    return remap$(v, {
      projectSlugHeaderGramProject: "project_slug_header_Gram-Project",
      sessionHeaderGramSession: "session_header_Gram-Session",
    });
  }),
);

export function getUserSessionIssuerSecurityOption1ToJSON(
  getUserSessionIssuerSecurityOption1: GetUserSessionIssuerSecurityOption1,
): string {
  return JSON.stringify(
    GetUserSessionIssuerSecurityOption1$outboundSchema.parse(
      getUserSessionIssuerSecurityOption1,
    ),
  );
}

/** @internal */
export type GetUserSessionIssuerSecurityOption2$Outbound = {
  "apikey_header_Gram-Key": string;
  "project_slug_header_Gram-Project": string;
};

/** @internal */
export const GetUserSessionIssuerSecurityOption2$outboundSchema: z.ZodMiniType<
  GetUserSessionIssuerSecurityOption2$Outbound,
  GetUserSessionIssuerSecurityOption2
> = z.pipe(
  z.object({
    apikeyHeaderGramKey: z.string(),
    projectSlugHeaderGramProject: z.string(),
  }),
  z.transform((v) => {
    return remap$(v, {
      apikeyHeaderGramKey: "apikey_header_Gram-Key",
      projectSlugHeaderGramProject: "project_slug_header_Gram-Project",
    });
  }),
);

export function getUserSessionIssuerSecurityOption2ToJSON(
  getUserSessionIssuerSecurityOption2: GetUserSessionIssuerSecurityOption2,
): string {
  return JSON.stringify(
    GetUserSessionIssuerSecurityOption2$outboundSchema.parse(
      getUserSessionIssuerSecurityOption2,
    ),
  );
}

/** @internal */
export type GetUserSessionIssuerSecurity$Outbound = {
  Option1?: GetUserSessionIssuerSecurityOption1$Outbound | undefined;
  Option2?: GetUserSessionIssuerSecurityOption2$Outbound | undefined;
};

/** @internal */
export const GetUserSessionIssuerSecurity$outboundSchema: z.ZodMiniType<
  GetUserSessionIssuerSecurity$Outbound,
  GetUserSessionIssuerSecurity
> = z.pipe(
  z.object({
    option1: z.optional(
      z.lazy(() => GetUserSessionIssuerSecurityOption1$outboundSchema),
    ),
    option2: z.optional(
      z.lazy(() => GetUserSessionIssuerSecurityOption2$outboundSchema),
    ),
  }),
  z.transform((v) => {
    return remap$(v, {
      option1: "Option1",
      option2: "Option2",
    });
  }),
);

export function getUserSessionIssuerSecurityToJSON(
  getUserSessionIssuerSecurity: GetUserSessionIssuerSecurity,
): string {
  return JSON.stringify(
    GetUserSessionIssuerSecurity$outboundSchema.parse(
      getUserSessionIssuerSecurity,
    ),
  );
}

/** @internal */
export type GetUserSessionIssuerRequest$Outbound = {
  id?: string | undefined;
  slug?: string | undefined;
  "Gram-Session"?: string | undefined;
  "Gram-Key"?: string | undefined;
  "Gram-Project"?: string | undefined;
};

/** @internal */
export const GetUserSessionIssuerRequest$outboundSchema: z.ZodMiniType<
  GetUserSessionIssuerRequest$Outbound,
  GetUserSessionIssuerRequest
> = z.pipe(
  z.object({
    id: z.optional(z.string()),
    slug: z.optional(z.string()),
    gramSession: z.optional(z.string()),
    gramKey: z.optional(z.string()),
    gramProject: z.optional(z.string()),
  }),
  z.transform((v) => {
    return remap$(v, {
      gramSession: "Gram-Session",
      gramKey: "Gram-Key",
      gramProject: "Gram-Project",
    });
  }),
);

export function getUserSessionIssuerRequestToJSON(
  getUserSessionIssuerRequest: GetUserSessionIssuerRequest,
): string {
  return JSON.stringify(
    GetUserSessionIssuerRequest$outboundSchema.parse(
      getUserSessionIssuerRequest,
    ),
  );
}
